import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';

export interface ManualOrderState {
  isLoading: boolean;
  objectId: string;
  error: {
    message: string;
    error: Error;
  };
}

export const manualOrderInitialState: ManualOrderState = {
  isLoading: false,
  objectId: '',
  error: {
    message: '',
    error: {
      name: '',
      message: '',
    },
  },
};

const manualOrderReducer = (
  state: ManualOrderState = manualOrderInitialState,
  action: ActionTypes,
): ManualOrderState => {
  switch (action.type) {
    case ActionKeys.MANUALORDER_SAVE_ORDER:
      return {
        ...state,
        isLoading: true,
      };
    case ActionKeys.MANUALORDER_SAVE_ORDER_SUCCESS:
      return {
        ...state,
        objectId: action.payload.objectId,
        isLoading: false,
      };
    case ActionKeys.MANUALORDER_SAVE_ORDER_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case ActionKeys.MANUALORDER_CLEAR_ERROR_MESSAGE:
      return {
        ...state,
        error: manualOrderInitialState.error,
      };
    case ActionKeys.MANUALORDER_RESET:
      return manualOrderInitialState;
    default:
      return state;
  }
};

export default manualOrderReducer;
